module.exports = __webpack_public_path__ + "static/media/media-and-advertising.87c95550.jpg";